var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"icon-name":"new"}},[_c('path',{staticClass:"blueStroke",attrs:{"d":"m 10,4 h 8 V 20 H 6 V 8 Z"}}),_c('path',{staticClass:"blueFill blueStroke",attrs:{"d":"m 6,8 h 4 V 4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }